import { render, staticRenderFns } from "./TatilTanimla.vue?vue&type=template&id=59d88480&"
import script from "./TatilTanimla.vue?vue&type=script&lang=js&"
export * from "./TatilTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports